var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.625 13.281a.608.608 0 0 0-.625.625v1.469c0 .375.25.625.625.625h4.75c.344 0 .625-.25.625-.625v-1.469a.627.627 0 0 0-.625-.625H4.75V6.625A.627.627 0 0 0 4.125 6h-3.5A.608.608 0 0 0 0 6.625v1.5c0 .344.25.625.625.625h.625v4.531H.625ZM3 0A2.26 2.26 0 0 0 .75 2.25C.75 3.5 1.75 4.5 3 4.5c1.219 0 2.25-1 2.25-2.25C5.25 1.031 4.219 0 3 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoText);
export default __webpack_public_path__ + "static/media/info-text.71e600dd70e87b17de09ebe79c8c1946.svg";
export { ForwardRef as ReactComponent };